// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7690 ? "81b54acc" : chunkId) + "." + {"1046":"3c23e0022ead637e","1127":"abbc7c3df94049e6","2084":"875ed373eee9d1b8","6991":"f299c51279524810","7690":"23c83cc98ec96dcd"}[chunkId] + ".js";
};